/**
 * /logistica/cargas/criar — Criar Carga em PLANEJADA.
 */
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiSave } from "react-icons/fi";

import AsyncButton from "../../../components/AsyncButton";
import EntityHeader from "../../../components/EntityHeader";
import { useAuth } from "../../../context/AuthContext";
import {
  criarCarga,
  listarMotoristas,
  listarVeiculos,
} from "../../../services/logistica";
import { PageContainer } from "../../../styles/shared";

import {
  Card,
  ErrorMsg,
  Input,
  SecondaryButton,
  SectionTitle,
  Select,
} from "../../Orcamentos/styles";


function amanhaISO() {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}


export default function CargaCriar() {
  const navigate = useNavigate();
  const { request } = useAuth();

  const [veiculos, setVeiculos] = useState([]);
  const [motoristas, setMotoristas] = useState([]);
  const [dataPlanejada, setDataPlanejada] = useState(amanhaISO());
  const [veiculoId, setVeiculoId] = useState("");
  const [motoristaId, setMotoristaId] = useState("");
  const [ajudanteNome, setAjudanteNome] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    Promise.all([
      listarVeiculos(request, { ativo: true }),
      listarMotoristas(request, { ativo: true }),
    ])
      .then(([v, m]) => {
        setVeiculos(Array.isArray(v) ? v : v?.results || []);
        setMotoristas(Array.isArray(m) ? m : m?.results || []);
      })
      .catch((err) => setError(err?.message || "Erro ao carregar cadastros."));
  }, [request]);

  const handleCriar = useCallback(async () => {
    if (!veiculoId) throw new Error("Selecione um veículo.");
    if (!motoristaId) throw new Error("Selecione um motorista.");
    if (!dataPlanejada) throw new Error("Informe a data.");
    const carga = await criarCarga(request, {
      data_planejada: dataPlanejada,
      veiculo_id: veiculoId,
      motorista_id: motoristaId,
      ajudante_nome: ajudanteNome,
    });
    navigate(`/logistica/cargas/${carga.id}`);
  }, [request, veiculoId, motoristaId, dataPlanejada, ajudanteNome, navigate]);

  return (
    <PageContainer>
      <EntityHeader
        title="Nova carga"
        subtitle="Planeja saída de caminhão - ADR-0026"
        actions={[
          {
            label: "Voltar",
            icon: <FiArrowLeft size={14} aria-hidden="true" />,
            onClick: () => navigate("/logistica/cargas"),
          },
        ]}
      />

      {error && <ErrorMsg>{error}</ErrorMsg>}

      <Card>
        <SectionTitle>Dados da carga</SectionTitle>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <span style={{ fontSize: 12, fontWeight: 600 }}>Data planejada *</span>
            <Input
              type="date"
              value={dataPlanejada}
              onChange={(e) => setDataPlanejada(e.target.value)}
            />
          </label>
          <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <span style={{ fontSize: 12, fontWeight: 600 }}>Veículo *</span>
            <Select value={veiculoId} onChange={(e) => setVeiculoId(e.target.value)}>
              <option value="">Selecione</option>
              {veiculos.map((v) => (
                <option key={v.id} value={v.id}>
                  {v.placa} - {v.descricao || v.tipo_display}
                </option>
              ))}
            </Select>
            {veiculos.length === 0 && (
              <small style={{ color: "var(--danger-text)" }}>
                Nenhum veículo cadastrado. Cadastre em /logistica/cadastros.
              </small>
            )}
          </label>
          <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <span style={{ fontSize: 12, fontWeight: 600 }}>Motorista *</span>
            <Select value={motoristaId} onChange={(e) => setMotoristaId(e.target.value)}>
              <option value="">Selecione</option>
              {motoristas.map((m) => (
                <option key={m.id} value={m.id}>{m.nome}</option>
              ))}
            </Select>
            {motoristas.length === 0 && (
              <small style={{ color: "var(--danger-text)" }}>
                Nenhum motorista cadastrado.
              </small>
            )}
          </label>
          <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <span style={{ fontSize: 12, fontWeight: 600 }}>Ajudante (opcional)</span>
            <Input
              value={ajudanteNome}
              onChange={(e) => setAjudanteNome(e.target.value)}
              maxLength={120}
              placeholder="Nome do ajudante"
            />
          </label>
        </div>
      </Card>

      <Card>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <SecondaryButton onClick={() => navigate("/logistica/cargas")}>
            Cancelar
          </SecondaryButton>
          <AsyncButton
            variant="primary"
            onClick={handleCriar}
            successMessage="Carga criada"
          >
            <FiSave size={14} /> Criar carga
          </AsyncButton>
        </div>
      </Card>
    </PageContainer>
  );
}
